import model from 'api'
import * as types from 'mutation-types'
import { getSessionStorage, setSessionStorage } from 'utils/storage'

const state = {
  list: [],
  total: 0,
  params: getSessionStorage('user_list_params') || {
    pageNo: 1,
    pageSize: 15
  },

  loadingList: false
}

const getters = {}

const mutations = {
  [types.USER_SET_LIST] (state, { list, total }) {
    state.list = list
    state.total = total
  },
  [types.USER_SET_LOADING_LIST] (state, loading) {
    state.loadingList = loading
  },
  [types.USER_UPDATE_PARAMS] (state, data) {
    state.params = Object.assign(state.params, data)
  }
}

const actions = {
  async getList ({ commit, state }) {
    try {
      commit(types.USER_SET_LOADING_LIST, true)
      const { list, total } = await model.User.getList(state.params)
      commit(types.USER_SET_LIST, { list, total })
    } catch (e) {
      commit(types.USER_SET_LIST, { list: [], total: 0 })
    } finally {
      setSessionStorage('user_list_params', state.params)
      commit(types.USER_SET_LOADING_LIST, false)
    }
  },
  async setParams ({ commit, dispatch }, data) {
    commit(types.USER_UPDATE_PARAMS, data)
    await dispatch('getList')
  },
  async changeState ({ commit, dispatch }, { userId, action }) {
    commit(types.USER_SET_LOADING_LIST, true)
    try {
      await model.User.changeState(userId, action)
      await dispatch('getList')
    } finally {
      commit(types.USER_SET_LOADING_LIST, false)
    }
  },
  async resetPassword ({ commit, dispatch }, { userId }) {
    commit(types.USER_SET_LOADING_LIST, true)
    try {
      await model.User.resetPassword(userId)
      await dispatch('getList')
    } finally {
      commit(types.USER_SET_LOADING_LIST, false)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
